
import {
    date,
    Dialog,
    Loading,
    QDate,
    QDialog,
    QInput,
    QItem,
    QItemLabel,
    QItemSection,
    QList,
    QMenu,
    QPopupProxy,
    QSeparator,
    QSpinner,
    QSpinnerDots
} from 'quasar'
import {isEmpty} from 'lodash-es'
import {between, numeric, required} from 'vuelidate/lib/validators'
import api from '../../services/api'
import dataManagerPanel from './panels/DataManagerPanel.vue'
import formDesignerPanel from './panels/FormDesignerPanel.vue'
import ReportDesignerPanel from './panels/ReportDesignerPanel.vue'
import ReportViewerPanel from './panels/ReportViewerPanel.vue'
import DistributionPanel from './panels/DistributionPanel.vue'
import {parse} from 'date-fns'
import {convertToISO_8601_String} from '../../utils/date-utils'
import BetaReportDesignerPanel from "./panels/BetaReportDesignerPanel.vue";

export default {
    components: {
      BetaReportDesignerPanel,
        QSpinnerDots,
        QInput,
        Dialog,
        QDialog,
        QSeparator,
        QDate,
        dataManagerPanel,
        formDesignerPanel,
        ReportDesignerPanel,
        ReportViewerPanel,
        DistributionPanel,
        QSpinner,
        QPopupProxy,
        QMenu,
        QList,
        QItem,
        QItemSection,
        QItemLabel},

    filters: {
        dateFilter: value => value ? convertToISO_8601_String(value, 'dd-MM-yyyy') : '',
    },

    data () {
        return {
            surveyEditModel: {
                dateRange: {
                    from: undefined,
                    to: undefined
                },
                title: '',
                usersGranted: ''
            },
            editTitle: false,
            user: this.$store.state.parantion.user.user,
            progress: 0,
            saveSurveyDataLoading: false,
            renderReportDesigner: false,
            renderFormDesigner: false,
            showSpinner: false
        }
    },

    computed: {
        displayRespondentNumbers () {
            if (this.activeSurvey.fields.frm_nonamed_users_granted) return this.activeSurvey.fields.frm_nonamed_users_used + '/' + this.activeSurvey.fields.frm_nonamed_users_granted
            return this.activeSurvey.fields.frm_nonamed_users_used
        },
        displayRespondentText () {
            if (this.activeSurvey.fields.frm_nonamed_users_granted) return this.$t('labels.used.surveyDetails') + '/' + this.$t('labels.granted.surveyDetails')
            return this.$t('labels.used.surveyDetails')
        },
        activeSurvey () {
            return this.$store.getters['survey/getActiveSurvey']
        },
        respondentsLeft () {
            return ((this.user.nonamed_users_granted - this.user.nonamed_users_used) + parseInt(this.activeSurvey.fields.frm_nonamed_users_used || 0))
        },
        surveysLeft () {
            return this.$store.state.parantion.user.user.forms_granted - this.$store.state.parantion.user.user.forms_used
        },
        getLastStep () {
            if (this.step1 === 2) return 1
            if (this.step2 === 2) return 2
            if (this.step3 === 2) return 3
            return 4
        },
        step1 () {
            if (this.$store.state.survey.templateObject.content) {
                return this.$store.state.survey.templateObject.content.version > 1 ? 1 : 2
            }
            return 1
        },
        step2 () {
            return (this.activeSurvey.fields.frm_nonamed_users_used && this.activeSurvey.fields.frm_nonamed_users_used !== 0) ? 1 : 2
        },
        step3 () {
            return this.progress > 50 ? 1 : 2
        },
        step4 () {
            try {
                const settings = JSON.parse(this.$store.state.survey.reportSettings)
                if (settings.reportOpened) return 1
            } catch (e) {
                return 2
            }
            return 2
        },
        step5 () {
            try {
                const settings = JSON.parse(this.$store.state.survey.reportSettings)
                if (settings.reportOpened) return 1
            } catch (e) {
                return 2
            }
            return 2
        },
        getDateRangeTo () {
            if (!this.surveyEditModel.dateRange.to) return ''
            return convertToISO_8601_String(new Date(this.surveyEditModel.dateRange.to), 'dd-MM-yyyy')
        },
        getDateRangeFrom () {
            if (!this.surveyEditModel.dateRange.from) return ''
            return convertToISO_8601_String(new Date(this.surveyEditModel.dateRange.from), 'dd-MM-yyyy')
        },
        isOpen () {
            const isExpired = new Date(this.activeSurvey.fields.frm_date_end) < new Date()
            if (isExpired) return false
            else return this.activeSurvey['frm_status'] === 1
        },
        checkDateBefore () {
            const dateToCheck = this.activeSurvey.fields.frm_date_start
            return date.getDateDiff(dateToCheck, Date.now(), 'days') > 0
        },
        checkDateAfter () {
        return new Date(this.activeSurvey.fields.frm_date_end) < new Date()
        },
        hasDemoReport () {
            return this.$store.state.parantion.user.config?.has_report_demo
        }
    },

    validations () {
        return {
            surveyEditModel: {
                usersGranted: {
                    between: between((this.activeSurvey.fields.frm_nonamed_users_used || 0), this.respondentsLeft),
                    numeric
                },
                title: {
                    required
                },
                dateRange: {
                    from: {
                        required
                    }
                }
            }
        }
    },

    async created () {
        this.$store.dispatch('parantion/template/setTemplateId', this.activeSurvey.template)
        setTimeout(() => {
            this.$store.commit('parantion/template/designer/SET_TEMPLATE_UPDATED', false)
        }, 3000)
    },

    async mounted () {
        this.calculateProgress()
    },

    methods: {
        minimumFormEndDate (date) {
            return parse(date, 'yyyy/MM/dd', new Date()) > parse(this.getDateRangeFrom, 'dd-MM-yyyy', new Date())
        },
        async calculateProgress () {
            let respondents = await this.$store.dispatch('survey/getFormUsersCount').then(res => res.status)

            if (respondents) {
                let total = respondents.progress_busy + respondents.progress_done + respondents.progress_remind + respondents.progress_invite
                this.progress = Math.round((respondents.progress_done * 100) / total);
            }
        },
        setEditTitle () {
            this.surveyEditModel.title = this.activeSurvey.frm_label
            this.editTitle = true
        },

        openEditSurveyModal () {
            this.surveyEditModel.dateRange.from = convertToISO_8601_String(this.activeSurvey.fields.frm_date_start)
            if (this.activeSurvey.fields.frm_date_end) {
                this.surveyEditModel.dateRange.to = convertToISO_8601_String(this.activeSurvey.fields.frm_date_end)
            }
            this.surveyEditModel.usersGranted = (this.activeSurvey.fields.frm_nonamed_users_granted === '0' || this.activeSurvey.fields.frm_nonamed_users_granted === 0) ? '' : this.activeSurvey.fields.frm_nonamed_users_granted
            this.surveyEditModel.title = this.activeSurvey.frm_label
            this.$refs.editSurveyModal.show()
        },

        copyThisSurvey () {
            this.$q.dialog({
                title: this.$t('survey_details.copy_survey_title.survey_details'),
                message: this.$t('survey_details.copy_survey_title_description.survey_details'),
                prompt: {
                    model: this.activeSurvey.frm_label,
                    isValid: val => this.activeSurvey.frm_label !== val,
                    type: 'text' // optional
                },
                cancel: {
                    label: this.$t('surveys.cancel.label'),
                    color: 'text-grey-10',
                    flat: true
                },
                ok: {
                    label: this.$t('survey_details.ok.close_survey'),
                },
                persistent: true
            }).onOk(data => {
                this.createNewCopySurvey(data)
            }).onCancel(() => {
                // console.log('>>>> Cancel')
            }).onDismiss(() => {
                // console.log('I am triggered on both OK and Cancel')
            })
        },

        async createNewCopySurvey (title) {
            this.$q.loading.show()
            try {
                //check surveys granted and users granted
                let templateObject = this.$store.getters['survey/getTemplate']

                // Create new survey object
                let newSurvey = {
                    frm_label: title,
                    content: templateObject.content.content,
                    respondents: this.activeSurvey.respondents
                }

                const form = await this.$store.dispatch('survey/createNewSurvey', newSurvey)

                const newSurveyHash = form.fh
                const surveys = await this.$store.dispatch('survey/getSurveys')
                const storedSurvey = surveys.find(s => s.fid === newSurveyHash)

                // set active survey
                this.$store.commit('survey/SET_ACTIVE_SURVEY', storedSurvey)
                await this.$store.dispatch('survey/getTemplate')
                await this.$store.dispatch('parantion/user/getUserFields', this.$store.state.parantion.user.user.uh)

                // check and set report
                if (templateObject.child.length >= 1) {
                    let report = await JSON.parse((await api.surveyService.getTemplateReportContent(templateObject.child[0])).data.content.content)
                    let response = await api.surveyService.postReportTemplate({
                        parent: storedSurvey.template,
                        content: JSON.stringify(report),
                        label: storedSurvey.frm_label
                    })
                }
                this.$q.loading.hide()
                this.$toasty.success(this.$t('surveys.new_survey_added.msg'))
                this.$router.push({path: `/surveys/details/${newSurveyHash}`})
            } catch (e) {
            }
        },

        checkIfDataChanged (respondents, dateRange, title) {
            let fields: {[x: string]: any} = {}
            if (!respondents) {
                respondents = ''
            }
            if (respondents !== this.activeSurvey.fields.frm_nonamed_users_granted) {
                fields.frm_nonamed_users_granted = respondents
            }
            if (dateRange.from) {
                if (!new RegExp(/[/ Z]+/).test(dateRange.from)) {
                    if (!this.activeSurvey.fields.frm_date_start || (dateRange.from !== fields.frm_date_start)) {
                        console.log('in here')
                        fields.frm_date_start = dateRange.from
                    } else {
                        console.log('%cin here :(', 'color:green')
                    }
                } else {
                    console.warn('Wrong date format')
                }
            }
            if (dateRange.to) {
                if (!new RegExp(/[/ Z]+/).test(dateRange.to)) {
                    if (!this.activeSurvey.fields.frm_date_end || (dateRange.to !== fields.frm_date_end)) {
                        fields.frm_date_end = dateRange.to
                    }
                } else {
                    console.warn('Wrong date format')
                }
            } else if (this.activeSurvey.fields.frm_date_end) {
                fields.frm_date_end = ''
            }
            if (title && title !== this.activeSurvey.frm_label) {
                fields.frm_label = title
            }

            return fields
        },

        updateCachedSurvey (fields) {
            if (fields.frm_nonamed_users_granted || fields.frm_nonamed_users_granted === '') {
                this.activeSurvey.fields.frm_nonamed_users_granted = fields.frm_nonamed_users_granted
            }
            if (fields.frm_date_end || fields.frm_date_end === '') {
                this.activeSurvey.fields.frm_date_end = fields.frm_date_end
            }
            if (fields.frm_date_start) {
                this.activeSurvey.fields.frm_date_start = fields.frm_date_start
            }
            if (fields.frm_label) {
                this.activeSurvey.frm_label = fields.frm_label
            }
            this.$store.commit('survey/SET_ACTIVE_SURVEY', this.activeSurvey)
        },

        async saveSurveyData () {
            this.saveSurveyDataLoading = true
            let fields = this.checkIfDataChanged(this.surveyEditModel.usersGranted, this.surveyEditModel.dateRange, this.surveyEditModel.title)
            if (!isEmpty(fields)) {
                let response = await api.surveyService.updateFields(this.activeSurvey.fid, fields, this.activeSurvey.template)
                  .then(() => {
                    this.$refs.editSurveyModal.hide()
                    this.saveSurveyDataLoading = false
                    this.$toasty.success(this.$t('survey_details.data_changed.toast'))
                    this.updateCachedSurvey(fields)
                  })
                  .catch(e => {
                    console.error(e)
                    this.saveSurveyDataLoading = false
                    this.$toasty.error(this.$t('survey_details.api_error.toast'))
                    this.$refs.editSurveyModal.hide()
                  })
                this.editTitle = false
            } else {
                this.saveSurveyDataLoading = false
                this.$refs.editSurveyModal.hide()
            }
        },

        changeSurveyStatus (status) {
            const parent = this
            const checkEndDate = this.surveyEditModel.dateRange.to ? new Date(this.surveyEditModel.dateRange.to) > new Date() : true

            if (status === 'close') {
                Dialog.create({
                    class: 'toggle-survey-state-modal',
                    title: parent.$t('survey_details.close_title.popup'),
                    message: parent.$t('survey_details.close_confirmation.popup', {count: 1}),
                    ok: parent.$t('survey_details.ok.close_survey'),
                    cancel: parent.$t('survey_details.cancel.close_survey')
                }).onOk(async () => {
                    let fieldObject = {'frm_status': 0}
                    parent.$store.dispatch('survey/updateActiveSurvey', fieldObject)
                    this.saveSurveyData()
                    this.$toasty.success(parent.$t('survey_details.close_success.toast'))
                })
            } else if (status === 'open') {
                if (checkEndDate) {
                    Dialog.create({
                        class: 'toggle-survey-state-modal',
                        title: parent.$t('survey_details.open_title.popup'),
                        message: parent.$t('survey_details.open_confirmation.popup', {count: 1}),
                        ok: parent.$t('survey_details.ok.open_survey'),
                        cancel: parent.$t('survey_details.cancel.open_survey')
                    }).onOk(async () => {
                        let fieldObject = {'frm_status': 1}
                        this.saveSurveyData()
                        parent.$store.dispatch('survey/updateActiveSurvey', fieldObject)
                        this.$toasty.success(parent.$t('survey_details.open_success.toast'))
                    })
                } else {
                    Dialog.create({
                        title: parent.$t('survey_details.open_title.popup'),
                        message: parent.$t('survey_details.open_date_failure.popup'),
                        ok: parent.$t('survey_details.ok.open_survey'),
                        cancel: parent.$t('survey_details.cancel.open_survey')
                    }).onOk(() => {
                        this.$toasty.error(parent.$t('survey_details.open_failure.toast'))
                    })
                }
            }
        },

        openDistribution () {
            this.$refs.distributionPanel.show()
        },

        openDataManager () {
            this.$refs.dataManager.show()
        },

        async formDesignerHide () {
            const newSurvey = await api.surveyService.getSurvey(this.activeSurvey.fid)
            await this.$store.commit('survey/SET_ACTIVE_SURVEY', newSurvey)
            this.renderFormDesigner = false
        },

        async openFormDesigner () {
            this.showSpinner = true
            await this.$store.dispatch('parantion/template/setTemplateId', this.activeSurvey.template)
            let template = await api.surveyService.getTemplate(this.activeSurvey.template)
            this.$store.dispatch('parantion/template/setTemplate', template.template)
            let vm = this
            this.renderFormDesigner = true
            this.$nextTick().then(function () {
                vm.$refs.formDesigner.show()
                vm.showSpinner = false
            })
        },

      async openFormDesignerVersionHistory () {
        await this.openFormDesigner()
          this.$nextTick().then(() => {
            this.$store.dispatch('parantion/template/designer/setViewMode', 4)
          })
      },

        reportDesignerHide () {
            this.$store.dispatch('parantion/template/setTemplateId', this.activeSurvey.template)
            this.renderReportDesigner = false
        },

        async openReportDesigner (demo) {
            this.renderReportDesigner = true
            let vm = this
            this.$nextTick().then(async function () {
                // First check if a template exists
                let template = await api.surveyService.getTemplate(vm.activeSurvey.template)
                template = template.template
                if (template.childs && template.childs.length >= 1) {
                    // Survey is expected to have 0 or 1 reports
                    vm.$refs.reportDesigner.show()
                    vm.$refs.reportDesigner.isLoading = true

                    const content = (await api.surveyService.getFormTemplateContent(template.childs[0])).data.content.content
                    await vm.$store.dispatch('parantion/template/setReportContentAndId', {
                        templateId: template.childs[0],
                        content: JSON.parse(content)
                    })
                } else {
                  if (demo === 'demo') {
                    vm.$refs.demoReportDesigner.show(true)
                  } else {
                    vm.$refs.reportDesigner.show(true)
                  }

                    vm.$refs.reportDesigner.isLoading = true
                }
                let settings = vm.$store.state.survey.reportSettings
                if (!settings) {
                    vm.$store.dispatch('survey/setReportSettings', {
                        settingsJson: {'reportOpened': true},
                        templateName: vm.activeSurvey.template
                    })
                } else {
                    try {
                        const json = JSON.parse(settings)
                        if (!json.reportOpened) {
                            vm.$store.dispatch('survey/setReportSettings', {
                                settingsJson: {'reportOpened': true},
                                templateName: vm.activeSurvey.template
                            })
                        }
                    } catch (e) {
                        vm.$store.dispatch('survey/setReportSettings', {
                            settingsJson: {'reportOpened': true},
                            templateName: vm.activeSurvey.template
                        })
                    }
                }
            })
        },

        goBack () {
            this.$router.push({path: '/surveys'})
        },

        async openSellProcess () {
            this.$store.dispatch('parantion/template/setTemplateId', this.activeSurvey.template)
            // Before we navigate we have to check if the survey is not already for sale in the store.
            let tn = this.activeSurvey.template
            let directusUrl = this.$store.getters['parantion/getDirectusUrl']
            let surveys = (await (await fetch(`${directusUrl}/items/survey_store_template_details?filter[tn][eq]=${tn}`)).json()).data
            if (surveys.length == 0){
                this.$router.push({name: 'SellProcess'})
            } else if (surveys.length > 0){
                this.$q.notify({
                    type: 'negative',
                    message: 'Vragenlijst staat al te koop.',
                    position: 'bottom-right',
                })
            }
        },

        openDeleteDialog () {
            this.$q.dialog({
                title: this.$t('survey_details.delete_title.title'),
                message: this.$t('survey_details.delete_confirmation.message'),
                class: 'delete-survey-dialog',
                cancel: {
                    label: this.$t('surveys.cancel.label'),
                    color: 'text-grey-10',
                    flat: true
                },
                ok: {
                    label: this.$t('surveys.delete.label'),
                    color: 'deep-orange'
                }
            }).onOk(() => {
                this.deleteSurvey()
            })
        },

        async deleteSurvey () {
            // go back to home
            const response = await this.$store.dispatch('survey/deleteSurvey', this.activeSurvey)
            if (response === 200) {
                this.$toasty.neutral(this.$t('survey_details.delete_success.message'))
                this.goBack()
            } else this.$toasty.error(this.$t('survey_details.delete_error.message'))
        }
    }
}
